<template>
<div :data-question-id="question.id">
    <div v-if="dimensionsMode === 'l'">
        <div v-if="sections_eSections.parentHeader" class="odr-appoint-header">
            <tpl :content="sections_eSections.parentHeader"/>
        </div>
        <div class="odr-appoint-filters__above">
            <div>
                <span v-if="sections_eSections.beforeFilters">
                    <tpl :content="sections_eSections.beforeFilters"/>
                </span>

                <template v-if="hasFilters">
                    <div
                        v-for="filter in filtersList"
                        :key="'filter.' + filter.id"
                        class="odr-filter-button"
                        :class="{'odr-filter-button_search': filter.type === 'search',
                                 'odr-filter-button_filled': currentFilters[filter.id] && currentFilters[filter.id].length}">
                        <block
                            v-if="filter.type === 'search'"
                            :id="filter.id"
                            :show-arrow="filtersShowArrow"
                            dropdown-shift="0"
                            type="input"
                            :state-id="stateId"
                            :value="currentFilters[filter.id][0]"
                            :settings="{ placeholder: filter.title, noBorderStyle: true }"
                            @input="value => { setFilters(filter.id, value.length ? [value] : []) }"/>
                        <block
                            v-else-if="filter.allowMultiple"
                            :id="filter.id"
                            :show-arrow="filtersShowArrow"
                            dropdown-shift="0"
                            padding="10px"
                            type="checkboxList"
                            :dropdown="true"
                            :suggest="filter.suggest === undefined && filter.values.length > $root.appConfig.providerListFilterSuggestMoreThan? true : filter.suggest"
                            :state-id="stateId"
                            :values="filter.values"
                            :value="currentFilters[filter.id]"
                            @input="(value) => { setFilters(filter.id, value) }"/>
                        <block
                            v-else
                            :id="filter.id"
                            :show-arrow="filtersShowArrow"
                            dropdown-shift="0"
                            padding="10px"
                            type="options"
                            :dropdown="true"
                            :suggest="filter.suggest === undefined && filter.values.length > $root.appConfig.providerListFilterSuggestMoreThan? true : filter.suggest"
                            :state-id="stateId"
                            :values="filter.values"
                            :value="currentFilters[filter.id]"
                            @input="(value) => { setFilters(filter.id, value !== null ? [value] : []) }"/>
                    </div>
                </template>

                <span v-if="sections_eSections.afterFilters">
                    <tpl :content="sections_eSections.afterFilters"/>
                </span>
                <div
                    v-if="question.settings.showWaitlist"
                    class="odr-filter-button"
                    :class="{'odr-filter-button_filled': activeWaitlistButton}">
                    <dropdown id="waitlist"
                              :ignoreTopScroll=true
                              :ignoreMaxHeight=true
                              :maxheight="700">
                        <text-link color="text">
                            <div class="odr-block__info"
                                 :class="{'odr-block__info_selected': activeWaitlistButton}"
                                 :style="`padding: 10px !important`">
                                {{ $trl('aw.waitlist_button') }}
                                <icon size="s">keyboard_arrow_down</icon>
                            </div>
                        </text-link>
                        <waitlistDialog
                            dropdownId="waitlist"
                            slot="content"
                            :providers="providers"
                            :submittedWaitlist="submittedWaitlist"
                            :waitlistSettings="question.settings.waitlistSettings"
                            @onRetrievedWaitlist="onRetrievedWaitlist"
                            :filteredCards="filteredCards"
                            :width="450">
                        </waitlistDialog>
                    </dropdown>
                </div>
            </div>
            <div>
                <div v-if="hasOrders" class="odr-filter-button odr-filter-button_no-border">
                    <block
                        id="ordering"
                        v-model="order"
                        :selected-styled="false"
                        :show-arrow="filtersShowArrow"
                        dropdown-shift="0"
                        padding="10px"
                        type="options"
                        :dropdown="true"
                        :state-id="stateId"
                        :values="orderOptions"/>
                </div>
            </div>
        </div>

        <div class="odr-widget-appoint">
            <div class="odr-widget-appoint__items">
                <div class="odr-sticky-area" data-sticky-area="appoint">
                    <sticky v-if="showDates" sticky-area="appoint" :z-index="1">
                        <div class="odr-widget-appoint__tab">
                            <div class="odr-appoint-filters__bar">
                                <div class="odr-appoint-filters__date">
                                    <div class="odr-filter-button__group">
                                        <tooltip v-if="hasLocations && maps.ready">
                                            <button
                                                slot="trigger"
                                                type="button"
                                                class="odr-filter-button odr-filter-button_group odr-filter-button_icon odr-filter-button_hoverable"
                                                @click="showMap = !showMap">
                                                <icon>public</icon>
                                            </button>
                                            <span v-if="showMap" slot="content">
                                                {{ $trl('aw.close_map') }}
                                            </span>
                                            <span v-if="!showMap" slot="content">
                                                {{ $trl('aw.map') }}
                                            </span>
                                        </tooltip>

                                        <dropdown id="calendar" :shift="97">
                                            <button type="button" class="odr-filter-button odr-filter-button_group odr-filter-button_icon odr-filter-button_hoverable">
                                                <icon>event</icon>
                                            </button>

                                            <calendar
                                                slot="content"
                                                :from="slots_data.availability.from || today"
                                                :to="slots_data.availability.to"
                                                :view-date="viewDate"
                                                :value="dates[0]"
                                                :no-after="slots_data.availability.to"
                                                :no-before="slots_data.availability.from"
                                                @input="selectDate"/>
                                        </dropdown>

                                        <tooltip :disabled="!prevDateDisabled">
                                            <button
                                                slot="trigger"
                                                type="button"
                                                :disabled="prevDateDisabled"
                                                class="odr-filter-button odr-filter-button_group odr-filter-button_icon"
                                                :class="{'odr-filter-button_hoverable': !prevDateDisabled}"
                                                @click="shiftDays(-1)">
                                                <icon size="m">
                                                    keyboard_arrow_left
                                                </icon>
                                            </button>
                                            <span slot="content">
                                                {{ $trl('aw.no_available_dates') }}
                                            </span>
                                        </tooltip>

                                        <div class="odr-filter-button__group-dates">
                                            <div
                                                v-for="day in dates"
                                                :key="day"
                                                class="odr-filter-button odr-filter-button_group odr-filter-button_date">
                                                {{ day | dateFormat('#day:3') }}
                                                <span class="odr-filter-button__sub">
                                                    {{ day | dateFormat('#month:3 %D') }}
                                                </span>
                                            </div>
                                        </div>

                                        <tooltip :disabled="!nextDateDisabled">
                                            <button
                                                slot="trigger"
                                                type="button"
                                                :disabled="nextDateDisabled"
                                                class="odr-filter-button odr-filter-button_group odr-filter-button_icon"
                                                :class="{'odr-filter-button_hoverable': !nextDateDisabled}"
                                                @click="shiftDays(1)">
                                                <icon size="m">
                                                    keyboard_arrow_right
                                                </icon>
                                            </button>
                                            <span slot="content">
                                                {{ $trl('aw.no_available_dates') }}
                                            </span>
                                        </tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </sticky>

                    <tpl v-if="sections_eSections.header" :content="sections_eSections.header"/>

                    <div
                        v-for="card in pagedCards"
                        :key="card.key"
                        class="odr-appoint odr-appoint_card"
                        :data-item="card.key"
                        @mouseover="hoveredKey = card.key"
                        @mouseout="hoveredKey = null">
                        <toggle :keep-opened-rest="true" :default-name="card.key" :use="cardsExpanded">
                            <div class="odr-appoint__wrap">
                                <div class="odr-appoint__info">
                                    <tpl :content="card.info"/>
                                </div>

                                <div
                                    v-if="showDates"
                                    class="odr-appoint__times"
                                    :class="{'odr-appoint__times_row': !card.display.slots}"
                                    :style="`${!card.display.slots ? 'width: '+ 95 * dates.length +'px !important' : ''}`">
                                    <div v-if="card.display.slots" class="odr-appoint-times">
                                        <div v-for="date in dates" :key="date" class="odr-appoint-times__place">
                                            <spinner
                                                v-if="slots_slotsFetching && slots_daysFetching.includes(date)"
                                                :simple="true"
                                                :size="'slot'"/>
                                            <div v-else class="odr-appoint-times__col">
                                                <div v-for="group in card.eSlotsGroups" :key="group.from+group.until">
                                                    <template v-if="group.periods[date]">
                                                        <button
                                                            v-for="slot in group.periods[date].slots"
                                                            :key="slot.value"
                                                            class="odr-appoint-time"
                                                            :class="{'odr-appoint-time_noon': !slot.morning}"
                                                            type="submit"
                                                            data-qa="providerslist.slot"
                                                            @click="slots_selectSlot(slot)">
                                                            {{ formatTime(slot.time) }}
                                                        </button>
                                                        <span
                                                            v-if="group.periods[date].more"
                                                            class="odr-appoint-time odr-appoint-time_ghost">
                                                            <toggle-trigger>
                                                                {{ group.showRestCount ? $trl('aw.n_more', group.periods[date].more) : $trl('aw.more') }}
                                                                <icon size="s">keyboard_arrow_down</icon>
                                                            </toggle-trigger>
                                                        </span>
                                                    </template>
                                                </div>
                                                <template v-if="slots_datesWithData.includes(date) && card.dashes[date] && card.dashes[date] !== 0">
                                                    <span v-for="(_, index) in (card.dashes[date] > 0 ? Array(card.dashes[date]).fill(true) : [])"
                                                          :key="index + date + 'dash'"
                                                          class="odr-appoint-time odr-appoint-time_dash">&mdash;</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="cardsExpanded[card.key] && card.display.slots"
                                        class="odr-appoint-collapse">
                                        <toggle-trigger>
                                            <toggle-icon>
                                                {{ $trl('aw.collapse') }}
                                            </toggle-icon>
                                        </toggle-trigger>
                                    </div>

                                    <div v-if="cardsExpanded[card.key] && card.display.slots && card.expandedInfo">
                                        <tpl :content="card.expandedInfo"/>
                                    </div>

                                    <button
                                        v-if="card.display.last"
                                        type="button"
                                        class="odr-appoint-time odr-appoint-time_button odr-appoint-time_button-last"
                                        @click="selectDate(card.display.last); $event.stopPropagation();">
                                        <span class="odr-appoint-time__last-icon">
                                            <span class="odr-appoint-time__icon">
                                                <icon size="m">keyboard_arrow_left</icon>
                                            </span>
                                        </span>

                                        <text-minor color="text">
                                            {{ $trl('aw.last_availability') }}
                                        </text-minor>
                                        <text-minor color="text" bold="true">
                                            {{ card.display.last | dateFormat('#day:3, #month:3 %D') }}
                                        </text-minor>
                                    </button>

                                    <button
                                        v-if="card.display.next"
                                        type="button"
                                        class="odr-appoint-time odr-appoint-time_button odr-appoint-time_button-next"
                                        @click="selectDate(card.display.next); $event.stopPropagation();">
                                        <text-minor color="text">
                                            {{ $trl('aw.next_availability') }}
                                        </text-minor>
                                        <text-minor color="text" bold="true">
                                            {{ card.display.next | dateFormat('#day:3, #month:3 %D') }}
                                        </text-minor>

                                        <span class="odr-appoint-time__next-icon">
                                            <span class="odr-appoint-time__icon">
                                                <icon size="m">keyboard_arrow_right</icon>
                                            </span>
                                        </span>
                                    </button>

                                    <div
                                        v-if="card.display.empty"
                                        class="odr-appoint__no-slots">
                                        <tpl :content="card.display.empty"/>
                                    </div>
                                </div>
                            </div>
                        </toggle>
                    </div>

                    <tpl v-if="sections_eSections.footer" :content="sections_eSections.footer"/>

                    <div
                        v-if="pagination.length > 1"
                        class="odr-pagination">
                        <div
                            v-for="page in pagination"
                            :key="page.number"
                            class="odr-pagination__item"
                            :class="{
                                'odr-pagination__item_selected': selectedPage === page.index
                            }"
                            @click="selectPage(page.index)">
                            {{ page.number }}
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="hasLocations && showMap"
                class="odr-appoint-map"
                data-sticky-area="map"
                :style="`flex-basis: ${mapWidth}px !important; width: ${mapWidth}px !important;`">
                <sticky :stretched="true" sticky-area="map">
                    <locations
                        class="odr-appoint-map__container"
                        :tpl-component="require('@/vue/markup/tpl.vue').default"
                        :hovered-key="hoveredKey"
                        :values="valuesForMap"/>

                    <button
                        v-if="showDates"
                        type="button"
                        class="odr-appoint-map__close"
                        @click="showMap = !showMap">
                        <icon>close</icon>
                    </button>
                </sticky>
            </div>
        </div>
    </div>
    <div v-if="dimensionsMode !== 'l'">
        <!-- :style="$root.appConfig.mode === 'chat' ? `min-height: ${dimensionsHeight - dimensionsChatHeaderHeight}px !important;` : ''" -->
        <div v-if="sections_eSections.parentHeader" class="odr-appoint-header">
            <span>
                <tpl :content="sections_eSections.parentHeader"/>
            </span>
        </div>
        <div class="odr-widget-appoint">
            <dropdown
                id="filters-fullscreen"
                :fullscreen="true">
                <div
                    slot="content"
                    class="odr-filters-view">
                    <div v-if="sections_eSections.beforeFilters">
                        <tpl :content="sections_eSections.beforeFilters"/>
                    </div>

                    <span>
                        <div
                            v-for="filter in filtersList"
                            :key="'mobile.' + filter.id"
                            class="odr-filters-view__block">

                            <block
                                v-if="filter.type === 'search'"
                                :id="filter.id"
                                type="input"
                                :state-id="stateId"
                                :value="currentFilters[filter.id][0]"
                                :settings="{ placeholder: filter.title }"
                                @input="value => { setFilters(filter.id, value.length ? [value] : []) }"/>
                            <block
                                v-else-if="filter.allowMultiple"
                                :id="'filtersMobile.' + filter.id"
                                type="checkboxList"
                                :state-id="stateId"
                                :title="filter.title"
                                :values="filter.values"
                                :value="currentFilters[filter.id]"
                                @input="(value) => { setFilters(filter.id, value) }"/>
                            <block
                                v-else
                                :id="'filtersMobile.' + filter.id"
                                type="radio"
                                :state-id="stateId"
                                :title="filter.title"
                                :values="filter.values"
                                :value="currentFilters[filter.id][0]"
                                @input="(value) => { setFilters(filter.id, value !== null ? [value] : []) }"/>
                        </div>
                    </span>

                    <div class="odr-filters-view__block">
                        <span class="odr-message">
                            {{ $trl('aw.sort_by') }}
                        </span>
                        <radio v-model="order" :values="orderOptions"/>
                    </div>

                    <div class="odr-filters-view__fixed-bottom">
                        <span class="odr-text_centered">
                            <tpl v-if="sections_eSections.afterFilters" :content="sections_eSections.afterFilters"/>
                        </span>

                        <main-button type="button" @click="hideDropdown('filters-fullscreen')">
                            {{ $trl('aw.show_doctors', filteredCards.length) }}
                        </main-button>
                    </div>
                </div>
            </dropdown>

            <dropdown
                id="calendar-fullscreen"
                :fullscreen="true"
                :on-close="() => {this.showMap = false;}">
                <locations
                    v-if="hasLocations && showMap"
                    slot="content"
                    :tpl-component="require('@/vue/markup/tpl.vue').default"
                    class="odr-appoint-map__container"
                    :values="valuesForMap"/>
            </dropdown>

            <dropdown
                id="waitlist-fullscreen"
                :fullscreen="true">
                <waitlistDialog
                    slot="content"
                    dropdownId="waitlist-fullscreen"
                    :submittedWaitlist="submittedWaitlist"
                    @onRetrievedWaitlist="onRetrievedWaitlist"
                    :providers="providers"
                    :waitlistSettings="question.settings.waitlistSettings"
                    :filteredCards="filteredCards">
                </waitlistDialog>
            </dropdown>

            <div class="odr-widget-appoint__items">
                <div class="odr-sticky-area" data-sticky-area="appoint">
                    <sticky sticky-area="appoint" :z-index="1">
                        <div class="odr-mobile-header">
                            <button
                                v-if="maps.ready"
                                type="button"
                                class="odr-mobile-header__item odr-mobile-header__item_buttons"
                                @click="showMap = true; showDropdown('calendar-fullscreen')">
                                <icon>room</icon>
                            </button>

                            <div v-if="showDates" class="odr-mobile-header__dates">
                                <button
                                    type="button"
                                    :disabled="prevDateDisabled"
                                    class="odr-mobile-header__item"
                                    @click="shiftDays(-1)">
                                    <icon>keyboard_arrow_left</icon>
                                </button>

                                <button
                                    type="button"
                                    :disabled="nextDateDisabled"
                                    class="odr-mobile-header__item"
                                    @click="shiftDays(1)">
                                    <icon>keyboard_arrow_right</icon>
                                </button>

                                <dropdown id="calendar-mobile" :fullscreen="true">
                                    <div class="odr-mobile-header__item">
                                        {{ dates[0] | dateFormat('#day:3, #month:3 %D') }}
                                    </div>
                                    <align-center slot="content">
                                        <calendar
                                            :from="slots_data.availability.from"
                                            :to="slots_data.availability.to"
                                            :view-date="viewDate"
                                            :value="dates[0]"
                                            :no-after="slots_data.availability.to"
                                            :no-before="slots_data.availability.from || today"
                                            @input="date => {selectDate(date); hideDropdown('calendar-mobile');}"/>
                                    </align-center>
                                </dropdown>
                            </div>

                            <button
                                v-if="showFilters"
                                type="button"
                                class="odr-mobile-header__item odr-mobile-header__item_buttons"
                                @click="showDropdown('filters-fullscreen')">
                                <icon>filter_list</icon>
                            </button>
                            <onetime-tooltip v-if="question.settings.showWaitlist" :show="showWaitlistTooltip" :submit="submitWaitlistTooltip">
                                <button
                                    v-if="question.settings.showWaitlist"
                                    type="button"
                                    slot="trigger"
                                    class="odr-mobile-header__item odr-mobile-header__item_buttons"
                                    :class="{'odr-mobile-header__item_selected': submittedWaitlist}"
                                    @click="showDropdown('waitlist-fullscreen')">
                                    <icon>access_alarm</icon>
                                </button>
                                <span slot="content">
                                    {{ $trl('aw.waitlist_tooltip_description') }}
                                </span>
                            </onetime-tooltip>

                        </div>
                    </sticky>

                    <tpl v-if="sections_eSections.header" :content="sections_eSections.header"/>

                    <div v-for="card in pagedCards"
                         :key="card.key"
                         class="odr-appoint odr-appoint_card"
                         :data-item="card.key">
                        <toggle :keep-opened-rest="true" :default-name="card.key" :use="cardsExpanded">
                            <div class="odr-appoint__small-info">
                                <tpl :content="card.info"/>
                                <gap v-if="cardsExpanded[card.key] && card.display.slots && card.expandedInfo" top="single">
                                    <tpl :content="card.expandedInfo"/>
                                </gap>
                            </div>
                        </toggle>

                        <div class="odr-appoint__slots" v-if="showDates">
                            <align-center v-if="slots_slotsFetching && slots_daysFetching.includes(dates[0])">
                                <spinner size="auto" :message="$trl('aw.slots_fetching')"/>
                            </align-center>

                            <align-center v-else-if="(card.periods[dates[0]] || []).length === 0 && !card.display.last && !card.display.next">
                                <text-regular bold="true"> {{ $trl('aw.no_slots') }} </text-regular>
                            </align-center>

                            <template v-if="(card.periods[dates[0]] || []).length">
                                <div class="odr-appoint__slot-group"
                                     v-for="(group, i) in card.eSlotsGroups"
                                     :key="i">
                                    <template v-for="slot in (group.periods[dates[0]] || []).slots">
                                        <div :key="slot.value" class="odr-appoint__slot">
                                            <gap top="single" bottom="single" block="true">
                                                <main-button
                                                    width="100%"
                                                    rounded="true"
                                                    type="submit"
                                                    :color="slot.morning ? 'minor' : undefined"
                                                    data-qa="providerslist.slot"
                                                    @click="slots_selectSlot(slot)">
                                                    {{ formatTime(slot.time) }}
                                                </main-button>
                                            </gap>
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <template v-if="card.display.last">
                                <div>
                                    <text-regular minor="true" color="text">
                                        {{ $trl('aw.last_availability') }}
                                    </text-regular>
                                    <text-regular color="text" bold="true">
                                        {{ card.display.last | dateFormat('#day:3, #month:3 %D') }}
                                    </text-regular>
                                </div>
                                <div>
                                    <icon size="s">keyboard_arrow_left</icon>
                                    <text-link bold="true" @click="selectDate(card.display.last)">
                                        {{ $trl('aw.go_to_date') }}
                                    </text-link>
                                </div>
                            </template>

                            <template v-if="card.display.next">
                                <div>
                                    <text-regular minor="true" color="text">
                                        {{ $trl('aw.next_availability') }}
                                    </text-regular>
                                    <text-regular color="text" bold="true">
                                        {{ card.display.next | dateFormat('#day:3, #month:3 %D') }}
                                    </text-regular>
                                </div>
                                <div>
                                    <text-link bold="true" @click="selectDate(card.display.next)">
                                        {{ $trl('aw.go_to_date') }}
                                        <icon size="s">keyboard_arrow_right</icon>
                                    </text-link>
                                </div>
                            </template>
                        </div>

                        <div class="odr-appoint__more" v-if="card.hasMoreInGroups[dates[0]] || cardsExpanded[card.key]">
                            <text-link v-if="!cardsExpanded[card.key]" @click="cardsExpanded[card.key] = true" bold="true">
                                {{ $trl('aw.view_all_cards') }} <icon key="keyboard_arrow_down">keyboard_arrow_down</icon>
                            </text-link>
                            <text-link v-else @click="cardsExpanded[card.key] = false" bold="true">
                                {{ $trl('aw.collapse') }} <icon key="keyboard_arrow_up">keyboard_arrow_up</icon>
                            </text-link>
                        </div>
                    </div>

                    <tpl v-if="sections_eSections.footer" :content="sections_eSections.footer"/>

                    <div
                        v-if="pagination.length > 1"
                        class="odr-pagination">
                        <div
                            v-for="page in pagination"
                            :key="page.number"
                            class="odr-pagination__item"
                            :class="{
                                'odr-pagination__item_selected': selectedPage === page.index
                            }"
                            @click="selectPage(page.index)">
                            {{ page.number }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/scss/blocks/appoint-collapse.scss';
import '@/scss/blocks/appoint-filters.scss';
import '@/scss/blocks/appoint-header.scss';
import '@/scss/blocks/appoint-time.scss';
import '@/scss/blocks/appoint-times.scss';
import '@/scss/blocks/appoint.scss';
import '@/scss/blocks/filter-button.scss';
import '@/scss/blocks/filters-view.scss';
import '@/scss/blocks/message.scss';
import '@/scss/blocks/mobile-header.scss';
import '@/scss/blocks/pagination.scss';
import '@/scss/blocks/sticky.scss';
import '@/scss/blocks/appoint-map.scss';
import '@/scss/blocks/widget-appoint.scss';

import { date2str, str2date, addDays, DATETIME_FORMAT, TIME_FORMAT } from '@/utils/format';
import dropdown from '@/vue/components/dropdown.vue';
import calendar from '@/vue/blocks/calendar.vue';
import radio from '@/vue/blocks/radio.vue';
import spinner from '@/vue/markup/spinner.vue';
import sticky from '@/vue/markup/sticky';
import { stickyRefresh } from '@/utils/sticky';
import slots from '@/utils/mixins/slots';
import sections from '@/utils/mixins/appoint-sections';
import { scrollBus } from '@/utils/scroll-bus';
import { hideDropdown, showDropdown } from '@/utils/dropdown';
import { filterBus, filterCards, applyFilters } from '@/utils/filter-cards';
import { requestCurrentPosition, getDistance } from '@/utils/position';
import { mapState } from 'vuex';
import { addParamToTpl } from '@/utils/plugins/tpl';

import mapsMixin from '@/utils/mixins/maps';
import { jsonCopy } from '@/utils/json';
import waitlistDialog from '@/vue/markup/waitlist-dialog';
import { Waitlist } from '@/types/waitlist';

export default {
    components: {
        waitlistDialog,
        sticky,
        dropdown,
        radio,
        calendar,
        spinner,
        locations: require('@clearwave/odoro-markup/lib/vue/locations.vue').default,
        tpl: require('@/vue/markup/tpl.vue').default,
        block: require('@/vue/block.vue').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        'align-center': require('@clearwave/odoro-markup/lib/vue/align-center.vue').default,
        gap: require('@clearwave/odoro-markup/lib/vue/gap.vue').default,
        'text-regular': require('@clearwave/odoro-markup/lib/vue/text-regular.vue').default,
        'text-link': require('@clearwave/odoro-markup/lib/vue/text-link.vue').default,
        'text-minor': require('@clearwave/odoro-markup/lib/vue/text-minor.vue').default,
        toggle: require('@clearwave/odoro-markup/lib/vue/toggle.vue').default,
        'toggle-trigger': require('@clearwave/odoro-markup/lib/vue/toggle-trigger.vue').default,
        'toggle-icon': require('@clearwave/odoro-markup/lib/vue/toggle-icon.vue').default,
        tooltip: require('@clearwave/odoro-markup/lib/vue/tooltip.vue').default,
        'main-button': require('@clearwave/odoro-markup/lib/vue/main-button.vue').default,
        'onetime-tooltip': require('@/vue/onetime-tooltip.vue').default,
    },
    mixins: [slots, sections, mapsMixin],
    props: {
        question: {
            type: Object,
            required: true,
        },
        stateId: {
            type: String,
            required: true,
        },
        mapWidth: {
            type: Number,
            default: 280,
        },
        showFilters: {
            type: Boolean,
            default: false,
        },
        datesMax: {},
        dashesLimit: {
            default: 4,
        },
        cardInfoWidth: {
            default: 415,
        },
        providersPerPage: {
            default: 10,
        },
        filterLocationsOnMap: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        let initialFilters = {};
        if (this.question.data.filters) {
            this.question.data.filters.forEach(filter => {
                initialFilters[filter.id] = [];
            });
        }
        const submittedWaitlist = this.question.data.submittedWaitlist;
        let cardsExpanded = {};
        this.question.data.slotCards.forEach(card => { cardsExpanded[card.key] = card.expanded; });

        return {
            today: date2str(new Date()),
            hoveredKey: null,
            initialFilters,
            cardsExpanded,
            submittedWaitlist,
            filtersSticked: false,
            activeWaitlistButton: !!submittedWaitlist,
        };
    },
    watch: {
        cardsExpanded: {
            deep: true,
            handler () {
                this.$nextTick(() => { // awaits markup to be changed
                    this.$store.dispatch('dimensions/SET_DIMENSIONS_RESIZE', { appConfig: this.$root.appConfig });
                });
            },
        },
        dimensionsMode (dimensionsMode, oldDimensionsMode) {
            if (dimensionsMode === 'l' &&
                this.showDates === false
            ) {
                this.showMap = true;
                return;
            }

            if (dimensionsMode !== 'l' &&
                oldDimensionsMode === 'l' &&
                this.showMap === true
            ) {
                this.showMap = false;
            }
        },
        filteredCards () {
            this.$nextTick(function () { // await content to be changed
                setTimeout(stickyRefresh, 300);
            });
        },
        showMap () {
            this.$nextTick(function () { // await content to be changed
                stickyRefresh();
            });
        },
        pagination () {
            if (this.pagination.length > 0 && this.selectedPage > this.pagination.length - 1) {
                this.selectPage(0);
            }
        },
    },
    mounted () {
        if (this.hasDistanceRequirements) {
            requestCurrentPosition(this.$root.appConfig);
        }

        filterBus.$on('filter-cards', options => {
            if (options.stateId !== this.stateId ||
                options.questionId !== this.question.id) {
                return;
            }

            hideDropdown('calendar-fullscreen');

            this.slots_setEffective('filters', applyFilters(this.currentFilters, this.initialFilters, options.applyCurrent, options.apply));
        });

        if (this.dimensionsMode !== 'l') {
            this.showMap = false;
        }

        this.selectedPage = this.selectedPage >= this.pagination.length ? this.pagination.length - 1
            : (this.selectedPage < 0 ? 0 : this.selectedPage);
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
            dimensionsWidth: 'width',
            dimensionsHeight: 'height',
            dimensionsChatHeaderHeight: 'chatHeaderHeight',
        }),
        showDates () {
            return this.question.data.effective.showDates !== false;
        },
        filtersShowArrow () {
            return this.question.data.effective.filtersShowArrow || true;
        },
        viewDate: {
            get () {
                let firstAvailable;

                let closestDatesPerResource = this.question.data.slotCards
                    .map(card => {
                        let dates = card.slots.map(slot => slot.datetime.split('T')[0]);
                        return card.nextAvailableDates ? dates.concat(card.nextAvailableDates) : dates;
                    })
                    .filter(dates => dates.length)
                    .map(dates => dates.map(date => str2date(date)))
                    .map(dates => Math.min.apply(Math, dates))
                    .filter(date => date >= str2date(this.today));

                if (closestDatesPerResource.length) {
                    firstAvailable = date2str(new Date(Math.min.apply(Math, closestDatesPerResource)));
                }

                return this.question.data.effective && this.question.data.effective.viewDate ||
                       firstAvailable ||
                       this.question.data.availability && this.question.data.availability.from ||
                       this.today;
            },
            set (value) { this.slots_setEffective('viewDate', value); },
        },
        selectedPage: {
            get () {
                return this.question.data.effective && this.question.data.effective.selectedPage || 0;
            },
            set (value) { this.slots_setEffective('selectedPage', value); },
        },
        showMap: {
            get () {
                return this.maps.ready &&
                       this.question.data.effective &&
                       this.question.data.effective.showMap;
            },
            set (value) { this.slots_setEffective('showMap', value); },
        },
        order: {
            get () {
                return this.question.data.effective && this.question.data.effective.order ||
                       this.question.data.orders[0] && this.question.data.orders[0].id;
            },
            set (value) { this.slots_setEffective('order', value); },
        },
        currentFilters () {
            return this.question.data.effective && this.question.data.effective.filters || {};
        },
        currentFiltersInfo () {
            let count = Object.keys(this.currentFilters).filter(key => this.currentFilters[key].length > 0).length;

            if (count) {
                return this.$trl('aw.n_filters', count);
            }
            return this.$trl('aw.filters');
        },
        valuesForMap () {
            return this.locations.values.map(location => {
                return {
                    items: (this.filterLocationsOnMap ? this.filteredCards : this.allCards).filter(card => card.filterProperties.location.includes(location.id)).map(card => card.key),
                    ...location,
                };
            }).filter(location => location.items.length);
        },
        pagination () {
            return Array(Math.ceil(this.sortedCards.length / this.providersPerPage))
                .fill(true)
                .map((_, index) => ({
                    index,
                    number: index + 1,
                    cards: this.sortedCards.slice(index * this.providersPerPage, (index + 1) * this.providersPerPage),
                }));
        },
        pagedCards () {
            return this.pagination.length ? this.pagination[this.selectedPage].cards : [];
        },
        filteredCards () {
            return filterCards(this.slots_data.filters, this.allCards, this.currentFilters);
        },
        filtersList () {
            return this.slots_data.filters.filter(filter => filter.visible && filter.webShowFilter);
        },
        locations () {
            return this.slots_data.filters.find(filter => filter.id === 'location');
        },
        hasOrders () {
            return this.filteredCards.length > 1 &&
                   this.orderOptions.length > 1;
        },
        providers () {
            const filterInfo = this.slots_data.filters.find((filter) => filter.presentForWaitlist);
            if (!filterInfo) {
                return [];
            }
            const filteredResourceIds = this.currentFilters.resource;
            let resources = filteredResourceIds.length === 0 ? filterInfo.values : filterInfo.values.filter(value => filteredResourceIds.includes(value.id));

            const providers = [];
            (resources || []).forEach(filter => {
                const matches = this.filteredCards.filter((card) => card.filterProperties.resource.includes(filter.id || ''));
                let location = [];
                matches.forEach(match => {
                    location = location.concat(match.filterProperties.location);
                });
                if (matches.length > 0) {
                    providers.push({
                        ...filter,
                        location,
                    });
                }
            });
            return providers;
        },
        hasFilters () {
            return this.filtersList.length;
        },
        orderOptions () {
            if (!this.slots_data.orders) {
                return [];
            }

            const orderValuesMap = new Map();

            this.allCards.forEach(card => {
                const orderProps = card.orderProperties || {};
                for (const [key, value] of Object.entries(orderProps)) {
                    if (typeof value === 'string' && value.trim() !== '') {
                        if (!orderValuesMap.has(key)) {
                            orderValuesMap.set(key, []);
                        }
                        orderValuesMap.get(key).push(value);
                    }
                }
            });

            return this.slots_data.orders.filter(order => {
                return !(order.type === 'distance' && !this.hasDistanceOrder) && orderValuesMap.get(order.id)?.length > 1;
            });
        },
        hasDistanceRequirements () {
            return !!(this.slots_data.slotCards &&
                      this.slots_data.slotCards.length &&
                      this.slots_data.orders &&
                      this.slots_data.orders.find(order => order.type === 'distance'));
        },
        hasDistanceOrder () {
            return !!(this.$root.appConfig.geoLocation &&
                      !this.$root.appConfig.geoLocation.pending &&
                      this.hasDistanceRequirements);
        },
        hasLocations () {
            if (this.slots_data.slotCards &&
                this.slots_data.slotCards.length &&
                this.slots_data.filters &&
                this.locations &&
                this.locations.values &&
                this.locations.values.find(location => location.map)
            ) {
                return true;
            } else {
                return false;
            }
        },
        dates () {
            return Array(this.numOfDays).fill(true).map((value, index) => {
                return date2str(addDays(str2date(this.viewDate), index));
            });
        },
        numOfDays () {
            if (this.dimensionsMode !== 'l') {
                return 1;
            }

            const MAP_WIDTH = this.showMap ? this.mapWidth : 0;
            const DATE_WIDTH = 95;

            let candidate = Math.max(1, Math.floor((this.dimensionsWidth - parseInt(this.cardInfoWidth) - MAP_WIDTH) / DATE_WIDTH));
            if (this.datesMax && this.datesMax < candidate) {
                return this.datesMax;
            }

            return candidate;
        },
        allCards () {
            if (!this.slots_data.slotCards) {
                return [];
            }

            return this.slots_data.slotCards.map(pCard => {
                let card = jsonCopy(pCard);
                let periods = {};
                let emptyPeriods = 0;
                let undefinedPeriods = 0;
                let dashes = {};

                card.slots.forEach(slot => {
                    let [date, time] = slot.datetime.split('T');

                    if (!periods[date]) {
                        periods[date] = [];
                    }

                    periods[date].push({
                        time,
                        datetime: slot.datetime,
                        cardInfo: card.info,
                        info: slot.info,
                        value: slot.value,
                        morning: parseInt(time.split(':', 1)[0], 10) < 12,
                        date: str2date(slot.datetime, DATETIME_FORMAT),
                        dateTime: str2date(time, TIME_FORMAT),
                    });
                });

                Object.keys(periods).forEach(date => {
                    periods[date].sort((a, b) => {
                        return a.date > b.date ? 1 : -1;
                    });
                });

                this.dates.forEach(date => {
                    dashes[date] = this.dashesLimit;
                    if (!periods[date]) {
                        emptyPeriods++;
                    }

                    if (!this.slots_datesWithData.includes(date)) {
                        undefinedPeriods++;
                    }
                });

                let nextAvailableDates;
                let showNextAvailable;
                let showLastAvailable;

                if (card.nextAvailable) {
                    nextAvailableDates = card.nextAvailable.map(slot => {
                        return slot.datetime.split('T')[0];
                    });
                }

                let noSlotsToDisplay = emptyPeriods === this.dates.length && undefinedPeriods === 0;

                if (noSlotsToDisplay) {
                    let findNextAt = Object.keys(periods)
                        .concat(nextAvailableDates || [])
                        .map(date => str2date(date).getTime())
                        .sort()
                        .find(date => date > str2date(this.dates[this.dates.length - 1]).getTime());

                    showNextAvailable = findNextAt ? date2str(new Date(findNextAt)) : null;

                    if (!showNextAvailable) {
                        let findLastAt = Object.keys(periods)
                            .map(date => str2date(date).getTime())
                            .sort()
                            .reverse()
                            .find(date => date < str2date(this.dates[0]).getTime());

                        showLastAvailable = findLastAt ? date2str(new Date(findLastAt)) : null;
                    }
                }

                let display = {
                    slots: false,
                    next: false,
                    last: false,
                    empty: false,
                };

                if (undefinedPeriods || emptyPeriods !== this.dates.length) {
                    display.slots = true;
                } else if (showNextAvailable) {
                    display.next = showNextAvailable;
                } else if (showLastAvailable) {
                    display.last = showLastAvailable;
                } else if (noSlotsToDisplay && card.noSlotsContent && !this.slots_daysFetching.length) {
                    display.empty = card.noSlotsContent;
                } else {
                    display.slots = true;
                }

                if (card.orderProperties && card.orderProperties.distance && this.hasDistanceOrder) {
                    card.orderProperties.distanceValue = getDistance(JSON.parse(card.orderProperties.distance), this.$root.appConfig);
                }

                let defaultGroup = [{
                    from: '00:00',
                    until: '24:00',
                    collapsedLength: 3,
                }];

                let expandedGroup = this.$root.appConfig.mode === 'chat' ? [
                    {
                        from: '00:00',
                        until: '12:00',
                        collapsedLength: 0,
                    }, {
                        from: '12:00',
                        until: '24:00',
                        collapsedLength: 0,
                    },
                ] : [{
                    from: '00:00',
                    until: '24:00',
                    collapsedLength: 0,
                }];

                let hasMoreInGroups = {};
                let eSlotsGroups = (this.cardsExpanded[card.key] ? card.slotsGroupsExpanded || expandedGroup : card.slotsGroups || defaultGroup).map(group => {
                    let eGroup = {
                        ...group,
                        periods: {},
                        fromMs: str2date(group.from, TIME_FORMAT),
                        untilMs: str2date(group.until, TIME_FORMAT),
                    };

                    Object.keys(periods).forEach(date => {
                        if (dashes[date] === undefined) {
                            dashes[date] = 4;
                        }

                        let period = periods[date]
                            .filter(slot => slot.dateTime >= eGroup.fromMs)
                            .filter(slot => slot.dateTime < eGroup.untilMs);

                        if (group.collapsedLength && (period.length - group.collapsedLength > 0)) {
                            let more = period.length - group.collapsedLength;
                            hasMoreInGroups[date] = more > 0;
                            eGroup.periods[date] = {
                                slots: period.slice(0, group.collapsedLength),
                                more,
                            };

                            dashes[date] -= group.collapsedLength + 1;
                        } else {
                            eGroup.periods[date] = {
                                slots: period,
                                more: 0,
                            };
                            hasMoreInGroups[date] = false;
                            dashes[date] -= period.length;
                        }
                    });

                    return eGroup;
                });

                let info = card.info;
                info = addParamToTpl(this.$root.appConfig, info, 'context-for-mobile', 'value', this.dimensionsMode !== 'l');
                info = addParamToTpl(this.$root.appConfig, info, 'context-for-desktop', 'value', this.dimensionsMode === 'l');

                return {
                    ...card,
                    info,
                    display,
                    opened: false,
                    periods,
                    eSlotsGroups,
                    hasMoreInGroups,
                    dashes,
                    nextAvailableDates,
                };
            });
        },
        sortedCards () {
            if (!(this.slots_data.orders && this.order)) {
                return this.filteredCards;
            }

            let eSortedCards = [...this.filteredCards].sort((aCard, bCard) => {
                let sort = (order, preventSub) => {
                    if (!order) {
                        return 0;
                    }

                    let result = 0;
                    let aValue;
                    let bValue;

                    if (order.type === 'distance' && this.hasDistanceOrder) {
                        aValue = aCard.orderProperties.distanceValue;
                        bValue = bCard.orderProperties.distanceValue;
                    } else if (order.type === 'numerical') {
                        aValue = parseFloat(aCard.orderProperties[order.id]);
                        bValue = parseFloat(bCard.orderProperties[order.id]);
                    } else if (order.type === 'alphabetical') {
                        aValue = String(aCard.orderProperties[order.id]);
                        bValue = String(bCard.orderProperties[order.id]);
                    }

                    result = aValue === bValue ? 0 : aValue > bValue ? 1 : -1;

                    if (order.subOrders && !preventSub) {
                        order.subOrders.forEach(subOrder => {
                            if (result !== 0) {
                                return;
                            }
                            let candidateResult = sort(this.orderOptions.find(order => order.id === subOrder), true);
                            if (candidateResult !== 0) {
                                result = candidateResult;
                            }
                        });
                    }

                    if (order.direction === 'descending') {
                        return result * -1;
                    } else {
                        return result;
                    }
                };
                return sort(this.orderOptions.find(order => order.id === this.order));
            });

            if (this.question.data.effective && this.question.data.effective.reverseOrder) {
                eSortedCards = eSortedCards.reverse();
            }

            return eSortedCards;
        },
        prevDateDisabled () {
            if (!this.slots_data.availability.from) {
                return false;
            } else {
                return str2date(this.slots_data.availability.from) >= str2date(this.dates[0]);
            }
        },
        nextDateDisabled () {
            if (!this.slots_data.availability.to) {
                return false;
            } else {
                return str2date(this.slots_data.availability.to) <= str2date(this.dates[this.dates.length - 1]);
            }
        },
        showWaitlistTooltip () {
            return this.$store.state.waitlist.showWaitlistTooltip;
        },
    },
    methods: {
        setFilters (filterId, value) {
            this.slots_setEffective('filters', {
                ...this.currentFilters,
                [filterId]: value,
            });
        },
        formatTime (time) {
            if (this.$root.appConfig.ampm) {
                return date2str(str2date(time, '%H:%M'), '%h:%M #ampm');
            }

            return time;
        },
        selectPage (page) {
            this.selectedPage = page;
            this.$nextTick(() => {
                this.$store.dispatch('dimensions/SET_DIMENSIONS_RESIZE', { appConfig: this.$root.appConfig });
                setTimeout(stickyRefresh, 300);
                scrollBus.$emit('scrollIntoStep', this.stateId);
            });
        },
        clearFilters () {
            this.slots_setEffective('filters', applyFilters(this.currentFilters, this.initialFilters, false, {}));
        },
        selectDate (dateString) {
            this.hideDropdown('calendar');

            let date = str2date(dateString);

            if (this.slots_data.availability.from && date < str2date(this.slots_data.availability.from)) {
                this.viewDate = this.slots_data.availability.from;
            } else if (this.slots_data.availability.from && this.slots_data.availability.to && addDays(str2date(this.slots_data.availability.from), this.numOfDays) > str2date(this.slots_data.availability.to)) {
                this.viewDate = date2str(date);
            } else if (this.slots_data.availability.to && addDays(date, this.numOfDays) > str2date(this.slots_data.availability.to)) {
                this.viewDate = date2str(addDays(str2date(this.slots_data.availability.to), (this.numOfDays * -1) + 1));
            } else {
                this.viewDate = date2str(date);
            }
        },
        shiftDays (delta) {
            let date = str2date(this.viewDate);
            date.setDate(date.getDate() + delta * this.numOfDays);
            this.selectDate(date2str(date));
        },
        submitWaitlistTooltip () {
            this.$store.commit('waitlist/SET_WAITLIST_TOOLTIP', false);
        },
        hideDropdown,
        showDropdown,
        onRetrievedWaitlist (status) {
            this.submittedWaitlist = this.$store.state.waitlist.data;
            this.activeWaitlistButton = status;
        },
    },
};
</script>
